import React, {useState, useEffect} from 'react';
import {Form, Dropdown, Dimmer, Loader, Radio, Progress, Icon, Button, Modal, Confirm} from 'semantic-ui-react';
import {toast, SemanticToastContainer} from 'react-semantic-toasts';
import {useDataMaintenance} from '../../providers/DataMaintenanceProvider';
import {useDataInspector} from '../../providers/DataInspectorProvider'; //TODO - pull this logic out of the DataInspector API route, it doesn't need to belong just to the data inspector
import styles from '../DataInspector/DataInspector.module.css';
import {useAuth} from "../../providers/AuthenticationProvider";
import {useNavigate} from "react-router";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';
import moment from "moment";
const WEB_PAGE = 'Data Maintenance';

const content = {
  marginTop: '2rem',
};

const progressBarSection = {
  width: '50%',
};

const toastSection = {
  marginTop: '2rem',
  whiteSpace: 'pre',
  width: '50%',
};

const modalType = {
  create: 'Create',
  edit: 'Edit'
}

export const DataMaintenance = () => {
  const { checkAuth, getUserType } = useAuth();

  const [weatherStationOptions, setWeatherStationOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [pointOptions, setPointOptions] = useState([]);
  const [functionOptions, setFunctionOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [deleteFunctionDataProgress, setDeleteFunctionDataProgress] = useState(0);
  const [progressLabel, setProgressLabel] = useState('');

  const [numericPointsSort, setNumericPointsSort] = useState([]);

  const [dataOption, setDataOption] = useState('Points');
  const [dataType, setDataType] = useState('EquipmentId');
  const [fromEquipmentPointId, setFromEquipmentPointId] = useState();
  const [vendorPointId, setVendorPointId] = useState();
  const [equipmentPointId, setEquipmentPointId] = useState();
  const [syrxControllerId, setSyrxControllerId] = useState();
  const [fromEquipmentId, setFromEquipmentId] = useState();
  const [weatherStationId, setWeatherStationId] = useState();
  const [functionId, setFunctionId] = useState();
  const [groupId, setGroupId] = useState();
  const [customerId, setCustomerId] = useState();
  const [buildingId, setBuildingId] = useState();
  const [equipmentId, setEquipmentId] = useState();
  const [pointId, setPointId] = useState();
  const [newPointValue, setNewPointValue] = useState();
  const [recalculateFunctions, setRecalculateFunctions] = useState(true);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [showEquipmentNumericPointModal, setShowEquipmentNumericPointModal] = useState(false);
  const [equipmentNumericPointModalType, setEquipmentNumericPointModalType] = useState(modalType.create);
  const [selectedEquipmentNumericPointId, setSelectedEquipmentNumericPointId] = useState(null);
  const [selectedEquipmentNumericPoint, setSelectedEquipmentNumericPoint] = useState('');
  const [selectedEquipmentNumericPointEffectiveDate, setSelectedEquipmentNumericPointEffectiveDate] = useState('');
  const [selectedEquipmentNumericPointValue, setSelectedEquipmentNumericPointValue] = useState();
  const [showDeleteNumericPointConfirmation, setShowDeleteNumericPointConfirmation] = useState(false);
  const navigate = useNavigate();

  checkAuth(getUserType(), WEB_PAGE) && navigate('/');

  const {
    weatherStations,
    getWeatherStations,
    postDataMaintenance,
    deleteFunctionData,
    calculateFunctions,
    getElasticTask,
    patchWeatherData,
    patchNumericPointData,
  } = useDataMaintenance();

  const {
    getDataInspectorGroups,
    getDataInspectorBuildings,
    getDataInspectorEquipment,
    getDataInspectorEquipmentPoints,
    getDataInspectorEquipmentFunctions,
    groups,
    buildings,
    equipment,
    points,
    functions,
    getNumericPoints,
    numericPoints,
    createNumericPoint,
    editNumericPoint,
    deleteNumericPoint
  } = useDataInspector();

  const handleSubmit = () => {
    var data = {
      DataType: dataType,
      FromEquipmentPointId: fromEquipmentPointId,
      VendorPointId: vendorPointId,
      EquipmentPointId: equipmentPointId,
      SyrxControllerId: syrxControllerId,
      WeatherStationId: weatherStationId,
      FromEquipmentId: fromEquipmentId,
      ToEquipmentId: equipmentId,
      Start: startDate,
      End: endDate,
    };
    setLoading(true);
    if (dataOption === 'Points') {
      postDataMaintenance(data).then(
        function (value) {
          setLoading(false);
          toast({
            type: 'success',
            description: value,
            animation: 'fade down',
            time: 0,
          });
        },
        function (error) {
            toast({
              type: 'error',
              description: 'Unable to delete Equipment Numeric Point',
              animation: 'fade down',
              time: 0,
          });
          setLoading(false);
        }
      );
    } else if (
      dataOption === 'Functions' &&
      (dataType === 'DeleteFunctionData' || dataType === 'DeleteFunctionDataByEquipment')
    ) {
      deleteFunctionData({
        functionId: functionId,
        startTime: startDate !== '' ? startDate : null,
        endTime: endDate !== '' ? endDate : null,
        equipmentId: equipmentId !== '' ? equipmentId : null,
      }).then(
        function (response) {
          setLoading(false);
          toast({
            type: 'success',
            description: response.message,
            animation: 'fade down',
            time: 0,
          });
          setShowProgressBar(true);
          setDeleteFunctionDataProgress(0);
          handleDeleteFunctionDataProgressBar(response.taskId);
        },
        function (error) {
          if (error.response.status === 400) {
            toast({
              type: 'error',
              description: error.response.data,
              animation: 'fade down',
              time: 0,
            });
          }
          setLoading(false);
        }
      );
    } else if (dataOption === 'Functions' && dataType === 'CalculateFunctions') {
      calculateFunctions({
        startTime: startDate !== '' ? startDate : null,
        endTime: endDate !== '' ? endDate : null,
        recalculateFunctions: recalculateFunctions,
        equipmentIds: equipmentId,
      }).then(
        function () {
          setLoading(false);
          toast({
            type: 'success',
            description: 'Function recalculation started',
            animation: 'fade down',
            time: 0,
          });
        },
        function (error) {
          if (error.response.status === 400) {
            toast({
              type: 'error',
              description: error.response.data,
              animation: 'fade down',
              time: 0,
            });
          }
          setLoading(false);
        }
      );
    } else if (dataOption === 'WeatherData') {
      patchWeatherData({
        startTime: startDate !== '' ? startDate : null,
        endTime: endDate !== '' ? endDate : null,
        weatherStationId: weatherStationId,
        customerId: customerId,
        equipmentId: equipmentId ?? buildingId,
      }).then(
        function () {
          setLoading(false);
          toast({
            type: 'success',
            description: 'Patching Weather Data',
            animation: 'fade down',
            time: 0,
          });
        },
        function (error) {
          if (error.response.status === 400) {
            toast({
              type: 'error',
              description: error.response.data,
              animation: 'fade down',
              time: 0,
            });
          }
          setLoading(false);
        }
      );
    } else if (dataOption === 'NumericPoint') {
      const newPointValueNumeric = parseFloat(newPointValue);

      if (isNaN(newPointValueNumeric)) {
        toast({
          type: 'error',
          description: 'New Numeric Point Value must be a number',
          animation: 'fade down',
          time: 0,
        });

        setLoading(false);
        return;
      }

      patchNumericPointData({
        startTime: startDate !== '' ? startDate : null,
        endTime: endDate !== '' ? endDate : null,
        equipmentId: equipmentId,
        pointId: pointId,
        newPointValue: newPointValueNumeric,
      }).then(
        function () {
          setLoading(false);
          toast({
            type: 'success',
            description: 'Patching Numeric Point Data',
            animation: 'fade down',
            time: 0,
          });
        },
        function (error) {
          if (error.response.status === 400) {
            toast({
              type: 'error',
              description: error.response.data,
              animation: 'fade down',
              time: 0,
            });
          }
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    getWeatherStations();
  }, [getWeatherStations]);

  useEffect(() => {
    let tempOptions = [];
    setWeatherStationOptions([]);
    weatherStations.forEach(weatherStation => {
      tempOptions.push({
        key: weatherStation.id,
        value: weatherStation.id,
        text: weatherStation.name,
      });
    });
    setWeatherStationOptions(tempOptions);
  }, [weatherStations]);

  useEffect(() => {
    getDataInspectorGroups();
  }, [getDataInspectorGroups]);

  useEffect(() => {
    let tempOptions = [];
    setGroupOptions([]);
    groups.forEach(group => {
      tempOptions.push({
        key: group.id,
        value: group.groupId,
        text: group.name,
      });
    });
    setGroupOptions(tempOptions);
  }, [groups]);

  useEffect(() => {
    let tempOptions = [];
    setBuildingOptions([]);
    buildings.forEach(equipmentItem => {
      tempOptions.push({
        key: equipmentItem.id,
        value: equipmentItem.id,
        text: `(${equipmentItem.id}) ${equipmentItem.name}`,
      });
    });
    setBuildingOptions(tempOptions);
  }, [equipment, buildings]);

  useEffect(() => {
    let tempOptions = [];
    setEquipmentOptions([]);
    equipment.forEach(equipmentItem => {
      tempOptions.push({
        key: equipmentItem.id,
        value: equipmentItem.id,
        text: `(${equipmentItem.id}) ${equipmentItem.name}`,
      });
    });
    setEquipmentOptions(tempOptions);
  }, [equipment]);

  useEffect(() => {
    if (points.length > 0 || functions.length > 0) {
      let tempOptions = [];
      setPointOptions([]);
      setFunctionOptions([]);

      //Munging point data into semeantic ui dropdown format
      let dividedEquipment = [];

      points.forEach(point => {
        if (point.pointType === 'NP') {
          let dividedEquipmentIndex = dividedEquipment.findIndex(
            e => e.equipmentId === point.equipmentId
          );

          if (dividedEquipmentIndex === -1) {
            dividedEquipment.push({
              equipmentName: point.equipmentName,
              equipmentId: point.equipmentId,
              points: [],
            });

            dividedEquipmentIndex = dividedEquipment.length - 1;
          }

          dividedEquipment[dividedEquipmentIndex].points.push({
            key: point.pointId,
            value: point.pointId,
            text: `(${point.equipmentId}) ${point.pointCode}`,
            type: 'point',
          });
        }
      });

      dividedEquipment.forEach(de => {
        if (de.points && de.points.length > 0) {
          tempOptions.push({
            key: de.equipmentId,
            // component: Dropdown.Header,
            children: (
              <>
                <span>{`${de.equipmentName} (${de.equipmentId})`}</span>
              </>
            ),
            className: styles.dropdownDivider,
          });

          de.points.forEach(point => {
            tempOptions.push(point);
          });
        }
      });

      setPointOptions(tempOptions);
      tempOptions = [];
      dividedEquipment = [];

      functions.forEach(function (functionItem, index) {
        let equipmentId = functionItem.equipmentId;

        if (typeof dividedEquipment[equipmentId] === 'undefined') {
          dividedEquipment[equipmentId] = {
            equipmentName: functionItem.equipmentName,
            equipmentId: functionItem.equipmentId,
            functions: [],
          };
        }

        dividedEquipment[equipmentId].functions.push({
          key: index,
          value: functionItem.functionId,
          text: `(${functionItem.equipmentId}) ${functionItem.name}`,
          type: 'function',
          buildingId: functionItem.equipmentId,
        });
      });

      dividedEquipment.forEach(de => {
        if (de.functions && de.functions.length > 0) {
          tempOptions.push({
            key: de.equipmentId,
            // component: Dropdown.Header,
            children: (
              <>
                <span>{`${de.equipmentName} (${de.equipmentId})`}</span>
              </>
            ),
            className: styles.dropdownDivider,
          });

          de.functions.forEach(functions => {
            tempOptions.push(functions);
          });
        }
      });

      setFunctionOptions(tempOptions);
    }
  }, [points, functions]);

  useEffect(() => {
    if (dataType !== 'EditNumericPoint' || (!buildingId && !equipmentId)) {
      return;
    }
    getNumericPoints(equipmentId ? equipmentId : buildingId, !!equipmentId);
  }, [dataType, buildingId, equipmentId, getNumericPoints]);

  const handleGroupChange = groupId => {
    setGroupId(groupId);
    setCustomerId(groupOptions.find(group => group.value === groupId).key);
    getDataInspectorBuildings(groupId);
    setEquipmentOptions([]);
  };

  const handleBuildingChange = buildingId => {
    setBuildingId(buildingId);
    getDataInspectorEquipment({
      buildingIds: [buildingId],
    });
    setEquipmentOptions([]);
  };

  const handleEquipmentChange = equipmentId => {
    setEquipmentId(equipmentId);
    if (!Array.isArray(equipmentId)) {
      getDataInspectorEquipmentPoints({
        buildingIds: buildingId ? [buildingId] : [],
        equipmentIds: equipmentId ? [equipmentId] : []
      });
      getDataInspectorEquipmentFunctions({
        buildingIds: buildingId ? [buildingId] : [],
        equipmentIds: equipmentId ? [equipmentId] : []
      });
    }
  };

  const handlePointChange = pointId => {
    setPointId(pointId);
  };

  const handleFunctionChange = functionId => {
    setFunctionId(functionId);
  };

  const handleDeleteFunctionDataProgressBar = taskId => {
    setTimeout(() => {
      getElasticTask(taskId).then(task => {
        const taskStatus = task?.Task?.status;
        if (taskStatus?.Total === 0) {
          setDeleteFunctionDataProgress(100);
        } else {
          setDeleteFunctionDataProgress(
            Math.round((taskStatus?.Updated / taskStatus?.Total) * 100)
          );
          const runningTime = task?.Task?.running_time_in_nanos / 1000000000;
          const estimatedTimeRemaining =
            (1.0 / (taskStatus?.Updated / taskStatus?.Total)) * runningTime - runningTime;
          setProgressLabel(
            `${taskStatus?.Updated}/${taskStatus?.Total} - Time Elapsed: ${timeDisplay(
              runningTime
            )} - Estimated Time Remaining: ${timeDisplay(estimatedTimeRemaining)}`
          );
        }
        if (task.Completed) {
          toast({
            type: 'success',
            description: `Function deletion process completed`,
            animation: 'fade down',
            time: 0,
          });
        } else {
          handleDeleteFunctionDataProgressBar(taskId);
        }
      });
    }, 5000);
  };

  const handleEquipmentNumericPointSave = async () => {
    try {
      if (equipmentNumericPointModalType === modalType.create) {
        await createNumericPoint(selectedEquipmentNumericPoint, selectedEquipmentNumericPointEffectiveDate, selectedEquipmentNumericPointValue);
      } else {
        await editNumericPoint(selectedEquipmentNumericPointId, selectedEquipmentNumericPointEffectiveDate, selectedEquipmentNumericPointValue);
      }

      toast({
        type: 'success',
        description: `Equipment Numeric Point ${equipmentNumericPointModalType === modalType.create ? 'Created' : 'Edited'}`,
        animation: 'fade down',
        time: 0,
      });
    } catch (e) {
      toast({
        type: 'error',
        description: `Failed to ${equipmentNumericPointModalType === modalType.create ? 'Create' : 'Edited'} Equipment Numeric Point`,
        animation: 'fade down',
        time: 0,
      });
    }
    resetEquipmentNumericPoints();
    getNumericPoints(equipmentId ?? buildingId, !!equipmentId);
  }

  const handleEquipmentNumericPointCreate = (modalType) => {
    setEquipmentNumericPointModalType(modalType);
    setShowEquipmentNumericPointModal(true);
  }

  const handleEquipmentNumericPointEdit = (modalType, id, pointId, effectiveDate, value) => {
    setEquipmentNumericPointModalType(modalType);
    setSelectedEquipmentNumericPointId(id);
    setSelectedEquipmentNumericPoint(pointId);
    setSelectedEquipmentNumericPointEffectiveDate(new moment.utc(effectiveDate).format('yyyy-MM-DD'));
    setSelectedEquipmentNumericPointValue(value);
    setShowEquipmentNumericPointModal(true);
  }

  const handleEquipmentNumericPointDeleteConfirmation = (id) => {
    setShowDeleteNumericPointConfirmation(true);
    setSelectedEquipmentNumericPoint(id);
  }

  const handleEquipmentNumericPointDelete = async () => {
    try {
      await deleteNumericPoint(selectedEquipmentNumericPoint)
      toast({
        type: 'success',
        description: 'Numeric Point Deleted',
        animation: 'fade down',
        time: 0,
      });
    } catch (e) {
      toast({
        type: 'error',
        description: 'Unable to delete Equipment Numeric Point',
        animation: 'fade down',
        time: 0,
      });
    }
    resetEquipmentNumericPoints();
    setShowDeleteNumericPointConfirmation(false);
    getNumericPoints(equipmentId ?? buildingId, !!equipmentId);
  }

  const handleEquipmentNumericPointModalClose = () => {
    setShowEquipmentNumericPointModal(false)
    resetEquipmentNumericPoints();
  }

  const resetEquipmentNumericPoints = () => {
    setSelectedEquipmentNumericPointId(null);
    setSelectedEquipmentNumericPoint('');
    setSelectedEquipmentNumericPointEffectiveDate('');
    setSelectedEquipmentNumericPointValue(null);
  }

  const timeDisplay = seconds => {
    if (seconds > 3600) {
      return new Date(seconds * 1000).toISOString().substring(11, 16).toString();
    } else {
      return new Date(seconds * 1000).toISOString().substring(14, 19).toString();
    }
  };

  return (
    <div>
      <Dimmer active={loading}>
        <Loader size="massive" active={loading}></Loader>
      </Dimmer>
      <div style={content}>
        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <Radio
                label="Points"
                name="dataOption"
                value={dataOption}
                checked={dataOption === 'Points'}
                onChange={() => {
                  setDataOption('Points');
                  setDataType('EquipmentId');
                }}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Functions"
                name="dataOption"
                value={dataOption}
                checked={dataOption === 'Functions'}
                onChange={() => {
                  setDataOption('Functions');
                  setDataType('DeleteFunctionData');
                }}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Patch Weather Data"
                name="dataOption"
                value={dataOption}
                checked={dataOption === 'WeatherData'}
                onChange={() => {
                  setDataOption('WeatherData');
                  setDataType('WeatherData');
                }}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Numeric Points"
                name="dataOption"
                value={dataOption}
                checked={dataOption === 'NumericPoint'}
                onChange={() => {
                  setDataOption('NumericPoint');
                  setDataType('PatchNumericPoint');
                }}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            {dataOption === 'Points' ? (
              <>
                <Form.Field>
                  <Radio
                    label="Equipment Id"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'EquipmentId'}
                    onChange={() => setDataType('EquipmentId')}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Equipment Point Id"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'EquipmentPointId'}
                    onChange={() => setDataType('EquipmentPointId')}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Vendor Point Id"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'VendorPointId'}
                    onChange={() => setDataType('VendorPointId')}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Syrx Controller Id"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'SyrxControllerId'}
                    onChange={() => setDataType('SyrxControllerId')}
                  />
                </Form.Field>
              </>
            ) : null}
            {dataOption === 'Functions' ? (
              <>
                <Form.Field>
                  <Radio
                    label="Delete Function Data (by Function Id)"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'DeleteFunctionData'}
                    onChange={() => setDataType('DeleteFunctionData')}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Delete Function Data (by Equipment & Function Id)"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'DeleteFunctionDataByEquipment'}
                    onChange={() => setDataType('DeleteFunctionDataByEquipment')}
                  />
                </Form.Field>
                <Form.Field>
                  <Radio
                    label="Calculate Functions"
                    name="dataType"
                    value={dataType}
                    checked={dataType === 'CalculateFunctions'}
                    onChange={() => setDataType('CalculateFunctions')}
                  />
                </Form.Field>
              </>
            ) : null}
            {dataOption === 'NumericPoint' ? (
                <>
                  <Form.Field>
                    <Radio
                        label="Patch Numeric Point Data"
                        name="dataType"
                        value={dataType}
                        checked={dataType === 'PatchNumericPoint'}
                        onChange={() => setDataType('PatchNumericPoint')}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Radio
                        label="Edit Numeric Point Data"
                        name="dataType"
                        value={dataType}
                        checked={dataType === 'EditNumericPoint'}
                        onChange={() => setDataType('EditNumericPoint')}
                    />
                  </Form.Field>
                </>
            ) : null}
          </Form.Group>
          <Form.Group widths="equal">
            {dataType === 'EquipmentPointId' ? (
              <Form.Input
                label="From Equipment Point Id (Syrx Number)"
                placeholder="Equipment Point Id"
                value={fromEquipmentPointId}
                onChange={e => setFromEquipmentPointId(e.target.value)}
                required
              />
            ) : null}
            {dataType === 'VendorPointId' ? (
              <Form.Input
                label="Vendor Point Id"
                placeholder="Vendor Point Id"
                value={vendorPointId}
                onChange={e => setVendorPointId(e.target.value)}
                required
              />
            ) : null}
            {dataType === 'SyrxControllerId' ? (
              <Form.Input
                label="Syrx Controller Id"
                placeholder="Syrx Controller Id"
                value={syrxControllerId}
                onChange={e => setSyrxControllerId(e.target.value)}
                required
              />
            ) : null}
            {['EquipmentPointId', 'VendorPointId', 'SyrxControllerId'].includes(dataType) ? (
              <Form.Input
                label="To Equipment Point Id (Point Id Guid)"
                placeholder="Equipment Point Id"
                value={equipmentPointId}
                onChange={e => setEquipmentPointId(e.target.value)}
                required
              />
            ) : null}
            {dataType === 'EquipmentId' ? (
              <>
                <Form.Input
                  label="From Equipment Id"
                  placeholder="Equipment Id"
                  value={fromEquipmentId}
                  onChange={e => setFromEquipmentId(e.target.value)}
                  required
                />
              </>
            ) : null}
            {dataType === 'DeleteFunctionData' ? (
              <>
                <Form.Input
                  label="Function Id"
                  placeholder="Function Id"
                  value={functionId}
                  onChange={e => setFunctionId(e.target.value)}
                  required
                />
              </>
            ) : null}
            {dataType === 'WeatherData' ||
            dataType === 'PatchNumericPoint' ||
            dataType === 'EditNumericPoint' ||
            dataType === 'DeleteFunctionDataByEquipment' ||
            dataType === 'CalculateFunctions' ||
            dataType === 'EquipmentId' ? (
              <>
                <Form.Dropdown
                  style={{height: '38px'}}
                  defaultValue={groupId}
                  label="Group Id"
                  placeholder="Group Id"
                  options={groupOptions}
                  onChange={(e, {value}) => handleGroupChange(value)}
                  selection
                  search
                  required={dataType !== 'CalculateFunctions'}
                />
                <Form.Dropdown
                  style={{height: '38px'}}
                  label="Buildings"
                  placeholder="Buildings"
                  options={buildingOptions}
                  onChange={(e, {value}) => handleBuildingChange(value)}
                  selection
                  search
                  clearable
                  required={dataType !== 'CalculateFunctions'}
                />
                <Form.Dropdown
                  style={{height: '38px'}}
                  label="Equipment"
                  placeholder="Equipment"
                  options={equipmentOptions}
                  onChange={(e, {value}) => handleEquipmentChange(value)}
                  selection
                  search
                  clearable
                  required={dataType !== 'CalculateFunctions' && dataType !== 'WeatherData'}
                  multiple={dataType === 'CalculateFunctions'}
                />
              </>
            ) : null}
            {dataType === 'PatchNumericPoint' ? (
              <>
                <Form.Dropdown
                  style={{height: '38px'}}
                  label="Points"
                  placeholder="Points"
                  options={pointOptions}
                  onChange={(e, {value}) => {
                    handlePointChange(value);
                  }}
                  selection
                  search
                  clearable
                  required
                />
              </>
            ) : null}
            {dataType === 'DeleteFunctionDataByEquipment' ? (
              <>
                <Form.Dropdown
                  style={{height: '38px'}}
                  label="Functions"
                  placeholder="Functions"
                  options={functionOptions}
                  onChange={(e, {value}) => {
                    handleFunctionChange(value);
                  }}
                  selection
                  search
                  clearable
                  required
                />
              </>
            ) : null}
            {dataType === 'EditNumericPoint' ? (
              <>
                <Form.Button
                    style={{marginTop: '24px', height: '38px'}}
                    size={'large'}
                    type={'button'}
                    color={'blue'}
                    onClick={() => handleEquipmentNumericPointCreate(modalType.create)}
                >
                  Add Equipment Numeric Point
                </Form.Button>
              </>
            ) : null}
          </Form.Group>
          <Form.Group>
            {dataType === 'VendorPointId' ||
            dataType === 'SyrxControllerId' ||
            dataType === 'WeatherData' ? (
              <Form.Field
                width={8}
                label={'Weather Station'}
                control={Dropdown}
                fluid
                selection
                search
                options={weatherStationOptions}
                style={{height: '38px'}}
                onChange={(e, selected) => {
                  setWeatherStationId(selected.value);
                }}
                required
              />
            ) : null}
            {dataType === 'PatchNumericPoint' ? (
              <>
                <Form.Input
                  width={8}
                  type={'number'}
                  label="New Numeric Point Value"
                  placeholder="Value"
                  onChange={e => setNewPointValue(e.target.value)}
                  step={0.001}
                  required
                />
              </>
            ) : null}
            {dataType !== 'EditNumericPoint' ? (
              <>
                <Form.Input
                  width={4}
                  type={'date'}
                  defaultValue={startDate}
                  label="Time Range (start date)"
                  placeholder="Time Range"
                  onChange={e => setStartDate(e.target.value)}
                  required={dataType === 'WeatherData' || dataType === 'PatchNumericPoint'}
                />
                <Form.Input
                  width={4}
                  type={'date'}
                  defaultValue={endDate}
                  label="Time Range (end date)"
                  placeholder="Time Range"
                  onChange={e => setEndDate(e.target.value)}
                  required={dataType === 'WeatherData' || dataType === 'PatchNumericPoint'}
                />
              </>
            ) : null}
            {dataType === 'CalculateFunctions' ? (
              <Form.Field width={8}>
                <Form.Checkbox
                  toggle
                  label="Recalculate All Functions"
                  checked={recalculateFunctions}
                  onChange={() => setRecalculateFunctions(!recalculateFunctions)}
                />
              </Form.Field>
            ) : null}
          </Form.Group>
          {dataType !== 'EditNumericPoint' ? (
              <Form.Group>
                <Form.Button
                    width="3"
                    size={'large'}
                    type={'submit'}
                    color={'blue'}
                    onClick={handleSubmit}
                >
                  Submit
                </Form.Button>
              </Form.Group>
          ) : null}
        </Form>
        {dataType === 'EditNumericPoint' ? (
            <div>
              <Grid
                data={orderBy(numericPoints, numericPointsSort)}
                sortable={true}
                sort={numericPointsSort}
                onSortChange={e => setNumericPointsSort(e.sort)}
              >
                <Column field="equipmentId" title="Equipment Id" />
                <Column field="pointCode" title="Point Code" />
                <Column
                  field="effectiveDate"
                  title="Effective Date"
                  cell={props => <td>{moment(props.dataItem.effectiveDate).utc().format('MM/DD/YYYY')}</td>}
                />
                <Column field="pointValue" title="Value" />
                <Column
                  title="Actions"
                  sortable={false}
                  cell={props => (
                    <td>
                      <Button size="small" color="blue" onClick={() => handleEquipmentNumericPointEdit(modalType.edit, props.dataItem.id, props.dataItem.equipmentPointId, props.dataItem.effectiveDate, props.dataItem.pointValue)}>
                        <Icon name="pencil" fitted={true} />
                      </Button>
                      <Button size="small" color="red" onClick={() => handleEquipmentNumericPointDeleteConfirmation(props.dataItem.id)}>
                        <Icon name="trash" fitted={true} />
                      </Button>
                    </td>
                  )}
                />
              </Grid>
            </div>
        ) : null}
      </div>
      {showProgressBar ? (
        <div style={progressBarSection}>
          <Progress
            percent={deleteFunctionDataProgress}
            indicating
            progress
            label={deleteFunctionDataProgress !== 100 ? progressLabel : ''}
          />
        </div>
      ) : null}
      <div style={toastSection}>
        <SemanticToastContainer position="bottom-center" />
      </div>
      <div>
        <Modal
          header={`${(equipmentNumericPointModalType === modalType.create ? 'Create' : 'Edit')} Equipment Numeric Point`}
          actions={['Close', {key: 'Save', content: 'Save', positive: true, onClick: () => {handleEquipmentNumericPointSave()}}]}
          size={'large'}
          open={showEquipmentNumericPointModal}
          onClose={handleEquipmentNumericPointModalClose}
          onSubmit={handleEquipmentNumericPointSave}
          content={
            <div style={content}>
              <Form>
                <Form.Group style={{marginLeft: '1rem'}}>
                  <Form.Field width="3">
                    <Form.Dropdown
                      style={{height: '38px'}}
                      label="Point"
                      placeholder="Point"
                      defaultValue={selectedEquipmentNumericPoint}
                      options={pointOptions}
                      onChange={(e, {value}) => {
                        setSelectedEquipmentNumericPoint(value);
                      }}
                      selection
                      search
                      clearable
                      required
                      disabled={equipmentNumericPointModalType === modalType.edit}
                    />
                  </Form.Field>
                  <Form.Field width="3">
                    <Form.Input
                      type={'date'}
                      defaultValue={selectedEquipmentNumericPointEffectiveDate}
                      label="Effective Date"
                      placeholder="Effective Date"
                      onChange={e => setSelectedEquipmentNumericPointEffectiveDate(e.target.value)}
                      required
                    />
                  </Form.Field>
                  <Form.Field width="3">
                    <Form.Input
                      label="Value"
                      placeholder="Value"
                      defaultValue={selectedEquipmentNumericPointValue}
                      onChange={e => setSelectedEquipmentNumericPointValue(e.target.value)}
                      type={'number'}
                      step={0.001}
                      required
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
            </div>
          }
        ></Modal>
        <Confirm
            open={showDeleteNumericPointConfirmation}
            onCancel={() => setShowDeleteNumericPointConfirmation(false)}
            onConfirm={handleEquipmentNumericPointDelete}
            content={'Are you sure you want to delete this equipment numeric point?'}
            confirmButton="Confirm"
        />
      </div>
    </div>
  );
};
